import { InjectionToken } from '@angular/core';

export const YANDEX_METRIKA_ID = new InjectionToken<string>('YANDEX_METRIKA_ID');
